<template>
  <MainLayout />
</template>

<script setup>
import MainLayout from './layouts/MainLayout.vue'
</script>
